import { useMemo, type ReactNode } from 'react'
import { AccessContext, type AccessValue } from './accessContext'

type AccessProviderProps = {
  /** Сырые строки `/auth/me`: незнакомое право хранится и ничего не открывает. */
  permissions?: readonly string[]
  children: ReactNode
}

/** Права приходят с бэка (/auth/me) и кладутся сюда после загрузки сессии. */
export function AccessProvider({ permissions = [], children }: AccessProviderProps) {
  const value = useMemo<AccessValue>(() => ({ permissions: new Set(permissions) }), [permissions])

  return <AccessContext value={value}>{children}</AccessContext>
}
